export const styles = {
    backgrounds: [
        { className: "primary-bg-colour", colour: "#79c61c" },
        { className: "secondary-bg-colour", colour: "#0090d2" },
        { className: "navbar-bg-colour", colour: "#2D343B" }
    ],
    text: [
        { className: "primary-text", colour: "#FFFFFF" },
        { className: "secondary-text", colour: "#0090d2" }
    ],
    borders: [
        { className: "primary-border-colour", colour: "#79c61c" },
    ]
};
